import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../../store/slices/userSlice";

const StartUp: any = ({ children }: any) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const data: any = !!sessionStorage.getItem("data") ? JSON.parse(sessionStorage.getItem("data") as any) : null;
        dispatch(setUser({ ...data }))
    }, [])
    return (
        <>{children}</>
    )
};

export default StartUp;